/**
 * TRF London — Global JS
 * Handles: scroll reveal, nav transparency
 */

(function () {
  'use strict';

  // ── Scroll Reveal ────────────────────────────────────────────
  // Triggers .trf-visible on elements with .trf-reveal when in viewport.
  function initReveal() {
    var els = document.querySelectorAll('.trf-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: show all immediately
      els.forEach(function (el) { el.classList.add('trf-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('trf-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  // ── Transparent Header ────────────────────────────────────────
  // Adds .trf-header-scrolled to the header when user scrolls past the hero.
  function initTransparentHeader() {
    var header = document.querySelector('.shopify-section-group-header-group');
    if (!header) return;

    // Only apply transparent mode if the first section is the TRF hero
    var hero = document.querySelector('.trf-section-hero');
    if (!hero) return;

    header.classList.add('trf-header-over-hero');

    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY > 60;
      header.classList.toggle('trf-header-scrolled', scrolled);
    }, { passive: true });
  }

  // ── Init ──────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initTransparentHeader();
    });
  } else {
    initReveal();
    initTransparentHeader();
  }
})();
